/**
 * Rebase done on 16/08/2018
 */

/* Login Controller
** Author: Soc-dfsk -30
** Version: 1.0
** Date 10/01/2017 */
'use strict';
App.controller('LoginCtrl', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading',
    'offsetDST', 'mixPanelApi', 'organizationService', 'UsersClientService', 'sessionService', 'sessionTimeout', 'errorHandler', '$location',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, $localStorage, $sessionStorage,
              $state, Api, toastr, authApi, $stateParams, $loading, offsetDST,
              mixPanelApi, organizationService, UsersClientService, sessionService, sessionTimeout, errorHandler, $location) {
        ngDialog.close();
        $scope.user = {};
        var dialogId;
        $scope.coBrandedKEY = $stateParams.coBrandedKEY;

        this.loadOrganization = async function (key){
            const organization = await organizationService.get(key);
            $scope.logoURL = _.get(organization, 'facility.logoURL');
            $scope.hospitalId = _.get(organization, '_id');
            $scope.$apply();
        }
        
        if ($scope.coBrandedKEY){
           this.loadOrganization($scope.coBrandedKEY);
        }

        $scope.login = async function () {
            $loading.start('login');
            $scope.user.coBrandedUrl = $scope.coBrandedKEY;
            try {
                $localStorage['token'] = await UsersClientService.login($scope.user);
                errorHandler.run();
                await sessionService.updateProfessional();
                await sessionService.updateNotifications();
                sessionTimeout.start($localStorage['token']);
                try {
                    const { state, params } = JSON.parse($stateParams.r);
                    $state.go(state, params);
                } catch (e) {
                    $state.go('splash');
                }
            }catch (e) {
                toastr.error(e.message);
            } finally {
                $loading.finish('login');
            }
        }

        $scope.closePopup = function () {
            ngDialog.close(dialogId);
        }

        $scope.logout = function () {
            authApi.logout();
        }

        //============reset password model================
        $scope.resetPasswordModel = function () {
            $scope.reset = {};
            ngDialog.open({
                template: 'resetPassword-dialog',
                className: 'ngdialog-theme-default resetPasswordDialog',
                showClose: true,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope
            });
        };


        $scope.resetPasswordSubmit = function () {
            ngDialog.close();
            $loading.start('login');
            UsersClientService.forgotPassword($scope.reset.email)
                .then(function () {
                    toastr.success('Please check your email to reset password');
                })
                .catch(function (err) {
                    toastr.error(err.message);
                })
                .finally(() => $loading.finish('login'));
        };

    }]);
